module.exports = __webpack_public_path__ + "static/fish_bg_left-586ce00fe51ce995b651495d217e5f77.png";